import { getPartner } from 'selectors/entities'

export const getCurrentPartnerId = state => state.settings.currentPartnerId

export const getCurrentPartner = state => getPartner(getCurrentPartnerId(state))(state)

export const getIdentityPartners = state => (state.settings.identity ? state.settings.identity.partners : [])

export const getIdentityPortalUser = state => (
  state.settings.identity ? state.settings.identity.portalUser : null
)

export const getIdentityPortalSuperuser = state => (
  state.settings.identity ? state.settings.identity.portalSuperuser : null
)

export const getPortalUserSearchResults = state => state.settings.portalUserSearchResults

export const getPartnerSearchResults = state => state.settings.partnerSearchResults

export const getFeatureFlag = flag => state => state.settings.featureFlags[flag] || false

export const getRecaptchaSiteKey = state => state.settings.recaptchaSiteKey

export const getMarkets = state => state.settings.markets



/** WEBPACK FOOTER **
 ** ./src/selectors/settings/settings-selectors.js
 **/